import React from "react";
import {observer} from "mobx-react";
import {Button, Modal, Typography} from "@mui/material";
import styled from "@emotion/styled";
import {useViewController} from "data/services/locator";
import type {IModalErrorController} from "views/components/modals/modal_error/modal_error.controller";
import {Bindings} from "data/constants/bindings";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";
import {Exist} from "views/components/exist/exist.component";

const ModalContent = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;
	outline: none;
	max-width: 600px;
	width: 100%;
	background: #fff;
	padding: 20px 20px 40px;
	border-radius: 4px;
	text-align: center;

	@media screen and (max-width: 640px) {
		max-width: unset;
		left: 24px;
		right: 24px;
		width: auto;
		transform: translateY(-50%);
	}

	button {
		max-width: 300px;
		color: #000;
	}

	p {
		color: #000;
		text-align: center;
		font-feature-settings:
			"clig" off,
			"liga" off;
		font-family: var(--fontFamilyBase);
		font-size: 18px;
		font-style: normal;
		font-weight: normal;
		line-height: 123%; /* 44.28px */
		letter-spacing: -0.7px;

		&.title {
			font-size: 36px;
			font-weight: 600;
			text-transform: capitalize;
		}
	}
`;

const CloseBlock = styled.div`
	width: 100%;
	display: flex;
	justify-content: flex-end;
	align-items: center;
`;

const Icon = styled.div`
	width: 80px;

	svg {
		width: 100%;
		height: auto;
		fill: #c20000;
	}
`;

export const ModalError: React.FC = observer(() => {
	const {isOpen, modalContent, i18n, close} = useViewController<IModalErrorController>(
		Bindings.ModalErrorController
	);

	return (
		<Modal open={isOpen}>
			<ModalContent>
				<CloseBlock>
					<Button sx={{minWidth: 0}} onClick={close}>
						<CloseIcon />
					</Button>
				</CloseBlock>
				<Icon>
					<ErrorIcon />
				</Icon>
				<Typography className="title">
					{i18n.t(modalContent?.title ?? "modal.error.title", "Error")}
				</Typography>
				<Exist when={modalContent?.message}>
					<Typography>{modalContent?.message}</Typography>
				</Exist>
			</ModalContent>
		</Modal>
	);
});
